var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { color } from "../templates/ui";
const StyledContainer = styled.div `
  border-radius: ${props => (props.borderRadius ? "10px" : "0")};
  padding: ${props => {
    if (props.largeGutter) {
        return "30px";
    }
    if (props.mediumGutter) {
        return "25px";
    }
    if (props.noGutter) {
        return "0";
    }
    return "15px";
}};
  background-color: ${props => {
    if (props.isLoading) {
        return color.body.base;
    }
    if (props.gray) {
        return color.gray.base;
    }
    if (props.grayLight) {
        return color.gray.light;
    }
    if (props.orange) {
        return props.theme.primary;
    }
    if (props.blue) {
        return props.theme.tertiary;
    }
    if (props.appThemeName === "inkassier") {
        return props.theme.primary;
    }
    if (props.appThemeName === "invoned") {
        return color.gray.lightest;
    }
    return color.body.base;
}};
`;
const ContentContainer = (_a) => {
    var { children, largeGutter, mediumGutter, noGutter, gray, grayLight, orange, blue, hasShadow, borderRadius, isLoading } = _a, restProps = __rest(_a, ["children", "largeGutter", "mediumGutter", "noGutter", "gray", "grayLight", "orange", "blue", "hasShadow", "borderRadius", "isLoading"]);
    return (React.createElement(StyledContainer, Object.assign({ largeGutter: largeGutter, mediumGutter: mediumGutter, noGutter: noGutter, gray: gray, grayLight: grayLight, orange: orange, blue: blue, hasShadow: hasShadow, borderRadius: borderRadius, isLoading: isLoading }, restProps), children));
};
export default ContentContainer;
